import type { ReactNode } from 'react';
import { Box } from '@ff-it/ui';
import type { EmbeddedCompany } from 'types';
import type { ClientDiscountOwner } from '../discounts/owner';

/** Shared partition presentation. Terms editors are composed as independent children. */
export function ClientVendorTermsSection({
  owner,
  provider,
  actions,
  children,
}: {
  owner: ClientDiscountOwner;
  provider: EmbeddedCompany | null;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Box as="section" border="default" borderRadius="md" mb="4">
      <Box display="flex" alignItems="center" gap="3" p="3">
        <Box>
          <Box fontWeight="semibold">{owner.name}</Box>
          <Box color="secondary" textSize="sm">
            Provider: {provider?.title ?? 'Any provider'}
          </Box>
        </Box>
        {actions}
      </Box>
      {children}
    </Box>
  );
}
